<script setup lang="ts">
import { computed, type HTMLAttributes } from 'vue'
import equal from 'fast-deep-equal'
import { cn } from "@/lib/utils";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select'

import { gameFormatList } from '@/constants'

const model = defineModel<Drill<'gaming_configuration'>>()

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()

const gameFormatId = computed<string>(
  () => gameFormatList.find((el) => equal(el.value, model.value))!.id
)
const gameFormatValue = computed(() => gameFormatList.find((el) => el.id === gameFormatId.value))
function handleGameFormatChanged(id: string) {
  model.value = gameFormatList.find((el) => el.id === id)!.value
}
</script>

<template>
  <Select
    :model-value="gameFormatId"
    :disabled="gameFormatList.length === 1"
    @update:model-value="handleGameFormatChanged"
  >
    <SelectTrigger
      aria-label="Select game format"
      :class="cn(
                `bg-background-inactive border border-stroke-input
                flex items-center gap-2 outline-hidden
                data-[disabled]:bg-background-inactive data-[disabled]:border-white/5
                [&_svg]:h-6 [&_svg]:w-6 [&_svg]:shrink-0 
                [&>span]:line-clamp-1 [&>span]:flex [&>span]:w-full [&>span]:items-center [&>span]:gap-1 [&>span]:truncate`,
                props.class
              )"
    >
      <SelectValue>
        <div class="truncate">
          {{ gameFormatValue?.label }}
        </div>
      </SelectValue>
    </SelectTrigger>
    <SelectContent>
      <SelectItem
        v-for="item in gameFormatList"
        :key="item.id"
        :value="item.id"
        :textValue="item.label"
        class="[data-highlighted]:bg-background-active focus:border-background-active data-[state=checked]:bg-background-active px-4 py-2 focus:text-white"
      >
        <div
          class="[&_svg]:text-foreground flex items-center gap-3 [&_svg]:size-4 [&_svg]:shrink-0"
        >
          {{ item.label }}
        </div>
      </SelectItem>
    </SelectContent>
  </Select>
</template>
